import React, { useEffect, useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../context/WelletContext';
import { CircleSpinner } from 'react-spinners-kit';
import './AppUpdateRequestBanner.css';

const AppUpdateRequestBanner = () => {
  const isAppReloadRequired = useSelector((state) => state.app.isAppReloadRequired);
  const [isReloading, setIsReloading] = useState(false);
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);

  const handleAppUpdate = async () => {
    setIsReloading(true);
    // Navigate to home page first, then reload
    if (welletContext && welletContext.apis && welletContext.apis.tickets) {
      try {
        await welletContext.apis.tickets.post('/associates/appreloaded');
      } catch (e) {
        console.error(e);
      }
    }
    window.location.href = '/';
  };

  useEffect(() => {
    if (isAppReloadRequired) {
      document.body.classList.add('required-reload');
    }

    return () => {
      document.body.classList.remove('required-reload');
    };
  }, [isAppReloadRequired]);

  if (isReloading) {
    return (
      <div className='loading-app' style={{ zIndex: 1000 }}>
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`version-update-banner container ${isAppReloadRequired ? 'visible' : ''}`}>
      <div className='row justify-content-center'>
        <div className='col-12 col-md-7 col-lg-6 px-0'>
          <div className='version-update-content'>
            <span className='version-update-text'>{t('newVersion')}</span>
            <button className='version-update-button' onClick={handleAppUpdate}>
              {t('update')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// AppUpdateRequestBanner.propTypes = {
//   onUpdate: PropTypes.func.isRequired,
// };

export default AppUpdateRequestBanner;
